import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueGlobalCount } from '../../../store/emarsys/action';
import { PAGE_NAME_NEWS_TIPS_LIST } from '../../../constants/emarsys/news-tips-list';

const useImpressionNewsList = (
  firstRef: React.RefObject<HTMLElement>,
  pageTitle: string,
  pageCategory: string,
  pageNumber: number,
  sectionName: string
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isNewsListActive = getFlagValue(FLAG_ENUM.EMARSYS_NEWS_LIST);
      if (isAuth && isFlagActive && isNewsListActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: PAGE_NAME_NEWS_TIPS_LIST.BERITA_DAN_TIPS_LISTING_PAGE,
          page_url: window.location.href,
          page_title: pageTitle,
          page_category: pageCategory,
          page_number: pageNumber,
          section_name: sectionName,
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }

        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueGlobalCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth, pageCategory],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionNewsList;
